import React from 'react'
import PropTypes from 'prop-types'

import Switch from 'react-switch'

function SandboxInterceptSwitch(props) {
  const { tabIndex, isEnabled, onChange } = props
  return (
    <div id={`browser-tab-${tabIndex}-proxy-switch`} className="uk-flex uk-flex-middle uk-flex-row uk-flex-center">
      <Switch
        checked={isEnabled}
        onChange={onChange}
        offColor="#999999"
        onColor="#1e87f0"
        checkedIcon={false}
        uncheckedIcon={false}
        width={30}
        height={15}
      />
      <small className="uk-text-emphasis uk-margin-small-left" style={{ whiteSpace: 'nowrap' }}>
        Intercept Requests
      </small>
    </div>
  )
}
SandboxInterceptSwitch.propTypes = {
  tabIndex: PropTypes.number.isRequired,
  isEnabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default SandboxInterceptSwitch
